import React, { useState, useEffect, useRef } from "react";
import { importProgressJobs } from "Pages/Dashboard/sequences/ProgressJobs/ImportProgressJobsStore";
import { observer } from "mobx-react";
import { ReactComponent as RightArrow } from "Assets/svg/rightArrow.svg";

const LinearProgressLoader = observer(
  ({
    count = 0,
    progress = 0,
    showTitle = true,
    totalActiveBulkJobs = 0,
    totalInProgressJobs = 0,
    // "contact" default keeps every existing caller's wording unchanged.
    entityLabel = "contact"
  }) => {
    const entityLabelPlural = `${entityLabel}s`;
    const [displayProgress, setDisplayProgress] = useState(0);
    const [isExpandable, setIsExpandable] = useState(false);
    const intervalRef = useRef(null);
    const [isLoading, setIsLoading] = useState(true);

    const updateProgress = () => {
      const step = (progress - displayProgress) / 100; // Calculate the step increment
      const updateInterval = 100; // Update every 100 ms
      clearInterval(intervalRef.current); // Clear any existing interval
      intervalRef.current = setInterval(() => {
        setDisplayProgress(prevProgress => {
          if (prevProgress < progress) {
            return Math.min(prevProgress + step, progress);
          } else {
            clearInterval(intervalRef.current);
            return progress;
          }
        });
      }, updateInterval);
    };

    const showPopup = () => {
      importProgressJobs.setIsShowPopup(true);
    };

    const RightArrowIcon = () => {
      return (
        <span className="rightArrowIcon">
          <RightArrow />
        </span>
      );
    };

    useEffect(() => {
      if (progress > 0) {
        setDisplayProgress(progress);
      }
      updateProgress();
      return () => clearInterval(intervalRef.current); // Cleanup interval on unmount
    }, [progress]);

    useEffect(() => {
      clearInterval(intervalRef.current);
    }, []);

    useEffect(() => {
      setIsExpandable(totalInProgressJobs > 0 && totalActiveBulkJobs > 0);
    }, [totalInProgressJobs, totalActiveBulkJobs]);

    useEffect(() => {
      if (totalActiveBulkJobs > 0 || totalInProgressJobs > 0) {
        setIsLoading(false);
      }
    }, [totalActiveBulkJobs, totalInProgressJobs]);

    return (
      <div className={`progressContainer ${isLoading ? `loading` : ``}`}>
        <div
          className={`progressWrapper ${
            isExpandable ? `expanded` : `compact`
          } ${isLoading ? `loading` : ``}`}
        >
          {isLoading ? (
            <>
              <div className="progressMessage linear-background"></div>
              <div className="linearProgressBarWrapper linear-background"></div>
            </>
          ) : (
            <>
              <div
                className={`progressMessage ${
                  isExpandable ? `expanded` : `compact`
                }`}
              >
                {displayProgress <= 0 && showTitle && (
                  <div className="circularLoaderWrapper">
                    <div>
                      <div className="loader-1 center">
                        <span></span>
                      </div>
                    </div>
                  </div>
                )}
                {displayProgress <= 0 && showTitle && (
                  <h2>
                    {`Initializing your ${entityLabel} upload... `}
                    {totalActiveBulkJobs > 0
                      ? `(${totalActiveBulkJobs} ${
                          totalActiveBulkJobs > 1 ? "uploads" : "upload"
                        } queued)`
                      : ""}
                  </h2>
                )}
                {displayProgress > 0 && showTitle && (
                  <div className="progressMessageWrapper">
                    <div className="circularLoaderWrapper">
                      <div>
                        <div className="loader-1 center">
                          <span></span>
                        </div>
                      </div>
                    </div>
                    <h2>
                      {`Your ${entityLabelPlural} are being imported... `}{" "}
                      {totalInProgressJobs > 0 || totalActiveBulkJobs > 0
                        ? `(${
                            totalInProgressJobs > 0
                              ? totalInProgressJobs + " active"
                              : ""
                          }${
                            totalInProgressJobs > 0 && totalActiveBulkJobs > 0
                              ? ", "
                              : ""
                          }${
                            totalActiveBulkJobs > 0
                              ? totalActiveBulkJobs + " queued"
                              : ""
                          })`
                        : ""}
                    </h2>
                  </div>
                )}
              </div>
              {displayProgress > 0 && showTitle && (
                <div className="linearProgressBarWrapper">
                  <div className={"linearProgressBar"}>
                    <div className="backgroundProgress"></div>
                    <div
                      className={`linearProgress ${
                        displayProgress > 10 ? "applyTransition" : ""
                      }`}
                      style={{ width: `${displayProgress}%` }}
                    ></div>
                  </div>
                  <div className="totalPercentage">{`${Math.round(
                    displayProgress
                  )}%`}</div>
                </div>
              )}
            </>
          )}
        </div>
        {isLoading ? (
          <div className="viewDetailsBtnloader linear-background"></div>
        ) : (
          displayProgress > 0 &&
          displayProgress < 100 &&
          showTitle && (
            <div className="viewDetailsBtn" onClick={showPopup}>
              <div
                className="viewJobProgressDetails"
                icon={true}
                loader={false}
              >
                <div className="viewDetailsTextWrapper">View details</div>
              </div>
              <RightArrowIcon />
            </div>
          )
        )}
      </div>
    );
  }
);

export default LinearProgressLoader;
